import { connect } from 'react-redux';
import * as AutoCompleteActions from '../actions/autoCompleteActions';
import * as InvitesActions from '../actions/invitesActions';
import * as ActionCreators from '../actions/actionCreators';
import AutoComplete from '../components/autocomplete/autoComplete';

const mapStateToProps = state => ({
  translations: state.translations,
  error: state.error,
  inputAreaHeight: state.inputAreaHeight,
  userSearchResults: state.userSearchResults,
  userSearchResultsHeight: state.userSearchResultsHeight,
  userSearchStatus: state.userSearchStatus,
  userSearchInView: state.userSearchInView,
  selectedUsers: state.selectedUsers,
  hoverSelectedUserIndex: state.hoverSelectedUserIndex,
  autoCompleteTextAreaValue: state.autoCompleteTextAreaValue,
});

const mapDispatchToProps = dispatch => ({
  userSearch: (url, event) => {
    dispatch(AutoCompleteActions.userSearch(url, event));
  },

  userResultClick: (fullName, emailAddress, department, employeeId, event) => {
    dispatch(
      AutoCompleteActions.userResultClick(
        fullName,
        emailAddress,
        department,
        employeeId,
        event,
      ),
    );
  },
  checkForAndAddUser: () => {
    dispatch(AutoCompleteActions.checkForAndAddUser());
  },
  removeSelectedUserClick: index => {
    dispatch(ActionCreators.removeSelectedUserClick(index));
  },
  changeHoverSelectedUser: index => {
    dispatch(ActionCreators.changeHoverSelectedUser(index));
  },
  expandTextArea: () => {
    dispatch(InvitesActions.expandTextArea());
  },
  updateAutoCompleteTextAreaValue: value => {
    dispatch(ActionCreators.updateAutoCompleteTextAreaValue(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoComplete);
